import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserOrders,
  placeOrder,
  raiseComplaintOrder,
  complaintOrders,
} from "../thunks/orderThunk";
import { orderStatus } from "../../constants/commonConstants";

const createOrderSlice = createSlice({
  name: "createOrder",

  initialState: {
    formData: {},
    formDataFiles: [],

    userOrders: {
      orders: [],
      pagination: {},
    },
    pendingOrders: {
      orders: [],
      pagination: {},
    },
    inProgressOrders: {
      orders: [],
      pagination: {}
    },
    complaintOrders: {
      orders: [],
      pagination: {},
    },
  },
  reducers: {
    setFormDataGlobState(state, action) {
      state.formData = { ...state.formData, ...action.payload };
    },
    setFormDataFiles(state, action) {
      state.formDataFiles = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Place order
      .addCase(placeOrder.fulfilled, (state, action) => {
        console.log(action.payload);
        state.formData = {};
      })

      // Fetch user orders
      .addCase(fetchUserOrders.fulfilled, (state, action) => {
        const params = action.meta.arg;
        
        if(params?.orderStatus === orderStatus.PENDING_PAYMENT){
          // pending orders (pending Payment)
          state.pendingOrders.orders = action.payload.data?.data
          state.pendingOrders.pagination = action.payload.data?.pagination
        
        }else if(params?.multipleOrderStatus){
          // in progress orders
          state.inProgressOrders.orders = action.payload.data?.data
          state.inProgressOrders.pagination = action.payload.data?.pagination

        }else{
          // all orders
          state.userOrders.orders = action.payload.data?.data;
          state.userOrders.pagination = action.payload.data?.pagination;
        }
      })

      // Raise complaint order
      .addCase(raiseComplaintOrder.fulfilled, (state, action) => {
        console.log(action.payload);
      })

      // Get User Raised Complaint Orders
      .addCase(complaintOrders.fulfilled, (state, action) => {
        console.log('complaintOrders', action.payload);
        state.complaintOrders.orders = action.payload.data?.data;
        state.complaintOrders.pagination = action.payload.data?.pagination;
      });
  },
});

export const { setFormDataGlobState, setFormDataFiles } = createOrderSlice.actions;
export default createOrderSlice.reducer;
